import React from "react";

import Container from "../../../../../../../../components/Container";
import SelectInput from "../../../../../../../../components/Inputs/SelectInput";
import TruncatedSelectInput from "../../../../../../../../components/Inputs/SelectInput/TruncatedSelectInput";
import Spacer from "../../../../../../../../components/Spacer";
import Text from "../../../../../../../../components/Text";
import TextWithTooltipInfoIcon from "../../components/TextWithInfoIcon";

import { ChartType } from "../../../../store/enums";

import useChartOptions from "../ChartHooks/UseChartOptions/useChartOptions";
import OptionSettings, { dataSeriesTooltipText, metricTooltipText } from "../shared/OptionSettings";

const { xAxisRangeOptions } = OptionSettings[ChartType.ColumnChart];

// Document: For Column Chart, data series is summarizedByAxis and should be fit into x axis
// Metric row is anyAxis and should be fit into y axis
const ColumnChartOptions = () => {
	const {
		setYAxisColumnData,
		setDataSeries,
		visualizeOption,
		dataSeriesOptions,
		anyAxisOptions,
		previousVisualizeOption,
	} = useChartOptions(ChartType.ColumnChart);

	const yAxisOptions = anyAxisOptions;
	const yAxisOptionDefaultValue = yAxisOptions.length > 0 ? yAxisOptions[0].value : null;

	return (
		<>
			<SelectInput
				label="Data Series"
				labelProps={{ color: "neutral-9", weight: "semi-bold", size: "paragraph-3" }}
				results={dataSeriesOptions}
				value={visualizeOption?.dataSeries?.column}
				menuPortalTarget={document.body}
				menuPosition="fixed"
				onChange={(option) => setDataSeries("column", option.value)}
				info={{
					title: "Data Series",
					message: dataSeriesTooltipText,
					titleBottomLine: true,
				}}
			/>
			<Container marginTop="3px">
				<Container centerVertical marginBottom="5px" width={79}>
					<Text size="caption" color="neutral-9" weight="regular">
						Set Range
					</Text>
				</Container>
				<Container block>
					<SelectInput
						value={visualizeOption?.dataSeries?.rangeOption || "TOP_10"}
						results={xAxisRangeOptions}
						menuPortalTarget={document.body}
						menuPosition="fixed"
						onChange={(option) => setDataSeries("rangeOption", option.value)}
					/>
				</Container>
			</Container>
			<Container marginTop="3px" column>
				<TextWithTooltipInfoIcon text="Metric" tooltipMessage={metricTooltipText} />
				<Spacer height={1} />
				<TruncatedSelectInput
					value={
						visualizeOption?.yAxis?.column ||
						previousVisualizeOption?.yAxis?.column ||
						previousVisualizeOption?.xAxis?.column ||
						yAxisOptionDefaultValue
					}
					results={yAxisOptions}
					menuPortalTarget={document.body}
					menuPosition="fixed"
					onChange={(option) => setYAxisColumnData("column", option.value)}
				/>
			</Container>
		</>
	);
};

export default ColumnChartOptions;
